import { TennisCourtSvg } from "../components/sports/TennisCourtSvg.tsx";
import { useI18n } from "../i18n/context.tsx";
import styles from "./ComingSoon.module.css";
import { ComingSoonTemplate } from "./ComingSoonTemplate.tsx";

export function TennisAiPage() {
  const { t } = useI18n();
  return (
    <ComingSoonTemplate
      sport={t.tennis}
      variant="ai"
      badgeClass={styles.badgeTennis}
      svgPreview={<TennisCourtSvg />}
      seoTitle="ShootCreator Tennis AI - Coming Soon"
      seoDesc="AI-powered tennis stroke analysis with heart rate monitoring and voice transcription. Coming soon."
      canonicalPath="/tennis/ai"
    />
  );
}
